module.exports = __webpack_public_path__ + "static/bridge-value-framework-single-1bc8a45e17a408b94683abfb3c765c7f.png";